export function weightInvalid ( weight: string ) {
    const regex = new RegExp( '^-?([0]{1}.{1}[0-9]+|[1-9]{1}[0-9]*.{1}[0-9]+|[0-9]+|0)$' )
    const valid = regex.test( weight )
    if ( !valid ) {
        return true
    } else {
        return false
    }
}